import React from "react"
import { Switch, Route } from "react-router-dom"
import Home from "views/Home"
import AboutMe from "views/AboutMe"

export default function RouterView() {
	return (
		<Switch>
			<Route path="/" exact component={Home}></Route>
			<Route path="/aboutme" component={AboutMe}></Route>
		</Switch>
	)
}
